<template lang="pug">
  y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px")
    v-card
      v-card-title.pa-4
        div.h6.basic800--text Generate new affiliate link
      v-divider.basic300
      v-card-text.pa-4
        div.c1.primary400--text Your current link (https://yezza.link/{{ affiliate.slug }}) will not be associated to this affiliate account anymore.
        div.c1.primary400--text.my-3 Note: Avoid using phrase that might be misleading e.g. register, signup, test, trial, free etc. 
        v-form(ref="form")
          v-text-field.my-2(v-model="affiliateSlug" background-color="basic200" height="40" outlined dense placeholder="custom_link" :prefix="`https://yezza.link/`" hide-details="auto" :rules="rules.slug")
      v-card-actions.px-2.pb-4.pt-0
        v-spacer
        v-btn(text @click='showModal = false' depressed height=32 )
          .button-Aa-small.primary400--text| Cancel
        v-btn.mr-2(color='textColorAccent' depressed height=32 @click="clickSave" :loading="isLoading")
          .button-AA-small.basic100--text| Save

</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'GenerateAffiliateLink',
  props: ['open', 'propAffiliate'],
  data: () => ({
    isLoading: false,
    affiliateSlug: null,
    rules: {
      slug: [
        v => !!v || 'This field is required',
        v => !!v && v.length <= 50 || 'Number of character must not exceed 50',
        v => /^[A-Za-z0-9]+(?:-[A-Za-z0-9]+)*$/.test(v) || 'New link must be valid',
      ]
    }
  }),
  computed: {
    affiliate: {
      get() {
        return this.propAffiliate
      },
      set(newValue) {
        this.$emit('update:propAffiliate', newValue)
      }
    },
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  watch: {
  },
  mounted () {
    this.affiliateSlug = this.affiliate.slug
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    clickSave () {
      if (!this.$refs.form.validate()) {
        return
      }
      if (this.affiliate.slug === this.affiliateSlug) {
        this.showModal = false
        return
      }
      this.isLoading = true
      this.$axios.patch(`/partners/${this.affiliate.id}`, { slug: this.affiliateSlug })
        .then(resp => {
          this.affiliate.slug = resp.data.slug
          this.showModal = false
        })
        .catch(err => {
          this.showMessage(['error', err.response.data.error])
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>